export const TRANSLATION_NAME_SPACES = {
    TRANSLATIONS: 'translations',
    FALLBACK_TRANSLATIONS: 'fallback-translations',
};
